import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { logoutUser } from "../../../Action/userActions";

import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Box,
  Divider,
  useMediaQuery,
  useTheme,
  Badge,
} from "@mui/material";

import LoginIcon from "@mui/icons-material/Login";
import NotificationsIcon from "@mui/icons-material/Notifications";

import { NotificationsPanel } from "../../dashboardSummary/components/Navbar/NotificationsPanel";

import ToolsMenu from "./tools.jsx";

const RightHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const openMenu = (event) => setAnchorEl(event.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const logoutHandler = () => {
    dispatch(logoutUser());
    closeMenu();
    setTimeout(() => navigate("/login"), 0);
  };

  const toggleNotifications = () => setIsNotificationsOpen(!isNotificationsOpen);
  const closeNotifications = () => setIsNotificationsOpen(false);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: 0.5, sm: 1, md: 1.5 },
      }}
    >
      {isAuthenticated ? (
        <>
          <ToolsMenu />
          <IconButton
            onClick={toggleNotifications}
            size="small"
            sx={{ color: "white" }}
            aria-label="Notifications"
          >
            <Badge badgeContent={3} color="error">
              <NotificationsIcon fontSize={isMobile ? "small" : "medium"} />
            </Badge>
          </IconButton>

          <IconButton
            onClick={openMenu}
            size="small"
            sx={{ color: "white" }}
            aria-label="User menu"
          >
            <Box
              sx={{
                width: { xs: 32, sm: 36 },
                height: { xs: 32, sm: 36 },
                borderRadius: "50%",
                bgcolor: "#D0D0D0",
                color: "#fff",
                fontWeight: "bold",
                fontSize: { xs: "0.9rem", sm: "1rem" },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textTransform: "uppercase",
              }}
            >
              {user?.email?.charAt(0) || "U"}
            </Box>
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={closeMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                mt: 1,
                minWidth: 180,
                borderRadius: 2,
                py: 0.5,
              },
            }}
          >
            <Box sx={{ px: 2, py: 1 }}>
              <Typography variant="subtitle2" fontWeight={600} noWrap>
                {user?.email?.split("@")[0]}
              </Typography>
              <Typography variant="caption" color="text.secondary" display="block">
                Role: {user?.role || "User"}
              </Typography>
            </Box>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem onClick={logoutHandler} dense>
              Logout
            </MenuItem>
          </Menu>

          <NotificationsPanel isOpen={isNotificationsOpen} onClose={closeNotifications} />
        </>
      ) : (
        <IconButton
          component={Link}
          to="/login"
          size="small"
          sx={{ color: "white" }}
          aria-label="Login"
        >
          <LoginIcon fontSize={isMobile ? "small" : "medium"} />
          {!isMobile && (
            <Typography variant="body2" sx={{ ml: 0.5 }}>
              Login
            </Typography>
          )}
        </IconButton>
      )}
    </Box>
  );
};

export default RightHeader;
